module.exports = __webpack_public_path__ + "media/almir.50b9906e.mp4";